import axios from 'axios';
import { API_URL } from '@/constants/env';
import { HttpStatus } from './constants';
import { IApiError } from './interfaces';

export const api = axios.create({ baseURL: API_URL });

export class ServiceError extends Error implements Awaited<IApiError> {
  constructor(err: unknown) {
    const message = err instanceof Error ? err.message : 'Unknown service error';

    super(message);

    if (axios.isAxiosError(err) && err.response) {
      // TODO fix typings
      // @ts-ignore
      this.headers = err.response.headers;
      this.data = err.response.data;
      this.status = err.response.status;
    } else {
      this.headers = {};
      this.data = err;
      this.status = HttpStatus.INTERNAL_SERVER_ERROR;
    }
  }

  public readonly headers: Record<string, string | string[]>;

  public readonly data: any;

  public readonly status: HttpStatus;
}
